import { Form, Select } from 'antd'
import { ColumnProps } from 'antd/lib/table'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useColumnSearchProps } from '../../../../../../../components/Table/useColumSearchProps'
import { Formula } from '../../../../../../../features/formulas/types/Formula'
import { GraphType } from '../../../types'
import { CompanyDashboardItemContext, CompanyDashboardContextType } from '../../DashboardItemProvider'
import DashboardItemFields from '../DasboardItemFieds'
import SelectionTableInput from '../SelectionTableInput'
import { useCtxFormulas } from '../../../../../../../features/formulas/queries/useCtxFormulas'

const InternalKeyFigureChartFields = () => {
  const { t } = useTranslation()
  const { data: formulas = [] } = useCtxFormulas()
  const { companyDashboardItem } = useContext(CompanyDashboardItemContext) as CompanyDashboardContextType
  let selectableInternalKeyFigures: Formula[] = []
  if (companyDashboardItem?.params.representation.type === 'table') {
    selectableInternalKeyFigures = formulas
  } else {
    selectableInternalKeyFigures = formulas.filter(d => d.type === companyDashboardItem?.params.selectedType)
  }

  const columns: ColumnProps<Formula>[] = [
    {
      title: t(`global:name`),
      dataIndex: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      ...useColumnSearchProps('name')
    }
  ]

  return (
    <>
      <DashboardItemFields />
      <Form.Item label={t('dashboardPage:chart-type')} name={['params', 'representation', 'options', 'type']}>
        <Select
          options={Object.values(GraphType).map(type => ({
            value: type,
            label: t(`dashboardPage:${type}`)
          }))}
        />
      </Form.Item>
      <Form.Item label={t('global:keyFigure')} name={['params', 'keyFigureIds']}>
        <SelectionTableInput<Formula>
          dataSource={selectableInternalKeyFigures
            .filter(item => item.order !== null)
            .sort((a, b) => a.order - b.order)}
          columns={columns}
        />
      </Form.Item>
    </>
  )
}

export default InternalKeyFigureChartFields
